export enum StripePaymentStatus {
    COMPLETE = 'succeeded',
    OPEN = 'processing',
    EXPIRED = 'requires_payment_method',
    CANCELED = 'canceled',
    REQUIRES_ACTION = 'requires_action',
}
